import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.064 7.988c.31 0 .564-.252.533-.56a5.615 5.615 0 0 0-5.025-5.026c-.308-.03-.56.224-.56.534v4.491a.56.56 0 0 0 .562.562z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M13.182 10.172a5.615 5.615 0 0 1-6.786 3.19 5.61 5.61 0 0 1-3.901-6.404A5.62 5.62 0 0 1 5.768 2.84m7.296 5.148c.31 0 .564-.252.533-.56a5.615 5.615 0 0 0-5.025-5.026c-.308-.03-.56.224-.56.534v4.491a.56.56 0 0 0 .562.562z"
    }, null, -1)
  ]))]))
}
export default { render: render }